import { createRouter, createWebHistory } from 'vue-router'
import { restoreSession, session } from './session'
import LoginView from './views/LoginView.vue'
import HomeView from './views/HomeView.vue'
import ChangePasswordView from './views/ChangePasswordView.vue'
import AdminUsersView from './views/AdminUsersView.vue'
import AdminStationsView from './views/AdminStationsView.vue'
import AdminMonitoringView from './views/AdminMonitoringView.vue'
import AdminRunHistoryView from './views/AdminRunHistoryView.vue'
import AdminAuditLogView from './views/AdminAuditLogView.vue'
import ReportDetailView from './views/ReportDetailView.vue'

const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: '/login', name: 'login', component: LoginView, meta: { public: true } },
    { path: '/', redirect: { name: 'home' } },
    { path: '/reports', name: 'home', component: HomeView, meta: { requiresAuth: true } },
    { path: '/reports/:templateId', name: 'report-detail', component: ReportDetailView, meta: { requiresAuth: true } },
    { path: '/change-password', name: 'change-password', component: ChangePasswordView, meta: { requiresAuth: true } },
    { path: '/admin/users', name: 'admin-users', component: AdminUsersView, meta: { requiresAuth: true } },
    { path: '/admin/stations', name: 'admin-stations', component: AdminStationsView, meta: { requiresAuth: true } },
    { path: '/admin/monitoring', name: 'admin-monitoring', component: AdminMonitoringView, meta: { requiresAuth: true } },
    { path: '/admin/monitoring/runs', name: 'admin-run-history', component: AdminRunHistoryView, meta: { requiresAuth: true } },
    { path: '/admin/monitoring/audit', name: 'admin-audit-log', component: AdminAuditLogView, meta: { requiresAuth: true } },
    { path: '/:pathMatch(.*)*', redirect: { name: 'home' } },
  ],
})

router.beforeEach(async (to) => {
  if (!session.initialized) await restoreSession()

  if (to.meta.public) {
    if (session.user) return session.user.mustChangePassword ? { name: 'change-password' } : { name: 'home' }
    return true
  }
  if (to.meta.requiresAuth && !session.user) {
    return { name: 'login', query: { redirect: to.fullPath } }
  }
  if (session.user?.mustChangePassword && to.name !== 'change-password') {
    return { name: 'change-password' }
  }
  if (to.meta.admin && session.user?.role !== 'ADMIN') {
    return { name: 'home' }
  }
  return true
})

export default router
